import { useQuery } from "@tanstack/react-query";
import { queryKeys } from "../keys";
import { queryApi } from "../api";
import { getTokens } from "../../utils/tokens";

/** staleTime 5 хв для personal-info (max-age=300) */
const PERSONAL_INFO_STALE_MS = 5 * 60 * 1000;

export function usePersonalInfoQuery() {
  const hasToken = !!getTokens()?.access_token;

  return useQuery({
    queryKey: queryKeys.personalInfo,
    queryFn: queryApi.fetchPersonalInfo,
    enabled: hasToken,
    staleTime: PERSONAL_INFO_STALE_MS,
  });
}
